export const TRADE_TYPE = {
  '1': '服务费扣款',
  '2': '服务费退款',
  '3': '充值'
}
